import { StoreType, useActions } from 'utils/connect';
import { consumer } from '@tock/coretypes';
import { tocktix } from '@tock/protos/dist/types/clowncar';
import { useSelector } from 'react-redux';
import BusinessCollectionDataConfigurationForm, {
  BusinessCollectionDataConfigValues,
  emptyState,
} from 'routes/logged-in/data-configurations/BusinessCollectionDataConfigurationForm';
import _ from 'lodash';

interface Props {
  onComplete(): void;
}

const CreateBusinessCollectionDataConfigurationForm: React.FunctionComponent<
  React.PropsWithChildren<Props>
> = ({ onComplete }) => {
  const { actions } = useActions();
  const metroAreaList = useSelector((state: StoreType) => state.metroArea.metroAreaList);
  const initialValues = emptyState;

  const onSubmit = async (values: BusinessCollectionDataConfigValues) => {
    const fullIMetroArea: tocktix.messages.IMetroArea | undefined = metroAreaList.find(
      ({ name }) => name === values.metroArea
    );

    const configuration: consumer.ICollectionDataConfiguration = {
      name: values.name,
      collectionConfig: {
        ..._.omit(values, 'name'),
        metroArea: fullIMetroArea,
        offeringSearchType: values.offeringSearchType,
      },
    };
    await actions.consumerPage.createDataConfiguration(configuration);
    await actions.consumerPage.fetchAllCollectionDataConfigurations('ALL');

    onComplete();
  };

  const onClear = () => {
    onComplete();
  };

  return (
    <BusinessCollectionDataConfigurationForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      clearUpdatingConfig={onClear}
    />
  );
};

export default CreateBusinessCollectionDataConfigurationForm;
